import { render, staticRenderFns } from "./HeadBanner.vue?vue&type=template&id=3d0b770e&scoped=true"
import script from "./HeadBanner.vue?vue&type=script&lang=ts"
export * from "./HeadBanner.vue?vue&type=script&lang=ts"
import style0 from "./HeadBanner.vue?vue&type=style&index=0&id=3d0b770e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0b770e",
  null
  
)

export default component.exports